import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IVACORISSample } from '../interfaces/va-coris-sample';

@Injectable({
  providedIn: 'root'
})
export class VACORISSampleService {
  private rootUrl: string = "/api/va-coris-samples";

  constructor(private httpClient: HttpClient) { }

  public getVACORISSample(docNumber: string): Observable<IVACORISSample> {
    const url = this.rootUrl + "/" + docNumber;
    return this.httpClient.get<IVACORISSample>(url);
  }
}
